import { Box, Typography } from '@mui/material';
import React from 'react';

type IconAndTextProps = {
  icon: React.ReactNode;
  text: string;
};

export const IconAndText = (props: IconAndTextProps) => {
  const { icon, text } = props;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'start',
        py: 1,
      }}
    >
      {icon}
      <Typography variant='body1' ml={1}>
        {text}
      </Typography>
    </Box>
  );
};
